import React from 'react'
import { useTranslation } from 'react-i18next'
// @ts-ignore
import { LikeOutlined } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import ActionIconsContainer from './ActionIconsContainer'

type LikeIconProps = {
  postId: string
  displayText?: boolean
  iconColor?: string
}

const LikeIcon = ({ postId, displayText = true, iconColor }: LikeIconProps) => {
  const { t } = useTranslation()
  const theme = useDisplayTheme() as Theme
  const color = iconColor || sys[theme].text.placeholder

  return (
    <ActionIconsContainer
      tooltipContent={t('like')}
      message={displayText ? t('like') : ''}
      url={`https://twitter.com/intent/favorite?tweet_id=${postId}`}>
      <LikeOutlined color={color} />
    </ActionIconsContainer>
  )
}

export default LikeIcon
